export default __webpack_public_path__ + "static/media/8380.3274b2cc.svg";